// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__bCXfA","colCheckbox":"styles_colCheckbox__1cKKA"};